import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
Vue.use(Vuex)
// vuex 持久化
const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})
export default new Vuex.Store({
  state: {
    breadcrumbs: {},
    webNavList: []
  },
  mutations: {
    setBreadcrumbs: (state, data) => {
      state.breadcrumbs = data
    },
    setWebNavList: (state, data) => {
      state.webNavList = data
    }
  },
  actions: {
    
  },
  modules: {
  },
  plugins: [vuexLocal.plugin]
})
